import { ComponentType, FC, ReactElement, useEffect } from 'react'
import { useAuth } from './use-auth'

interface WithAuthenticationRequiredOptions {
  onRedirecting?: () => ReactElement
}

/** Drop-in replacement for the @auth0/auth0-react HOC of the same name. */
export const withAuthenticationRequired = <P extends object>(
  Component: ComponentType<P>,
  options?: WithAuthenticationRequiredOptions,
): FC<P> => {
  return function WithAuthenticationRequired(props: P) {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth()

    useEffect(() => {
      if (!isLoading && !isAuthenticated) {
        void loginWithRedirect()
      }
    }, [isLoading, isAuthenticated, loginWithRedirect])

    if (!isAuthenticated) {
      return options?.onRedirecting ? options.onRedirecting() : null
    }

    return <Component {...props} />
  }
}
